import { gql } from '@apollo/client';
import { DEPARTMENT_FRAGMENT } from '../departments/department.queries';
import { LOCATION_FRAGMENT } from '../locations/location.queries';
import { USER_OVERVIEW_FRAGMENT } from '../users/user.queries';
import { ENTITY_MEMBER_FRAGMENT } from '../entity-members/entity-members.queries';

export const CLIENT_OVERVIEW_FRAGMENT = gql`
  fragment ClientOverview on Client {
    _id
    name
    givenName
    familyName
    user {
      ...UserOverview
    }
    deletedAt
  }

  ${USER_OVERVIEW_FRAGMENT}
`;

export const CLIENT_FRAGMENT = gql`
  fragment ClientDetails on Client {
    _id
    name
    givenName
    familyName
    user {
      ...UserOverview
    }
    company {
      _id
    }
    deletedAt
    department {
      ...DepartmentDetails
    }
    location {
      ...LocationDetails
    }
  }

  ${DEPARTMENT_FRAGMENT}
  ${LOCATION_FRAGMENT}
  ${USER_OVERVIEW_FRAGMENT}
`;

export const GET_CLIENTS = gql`
  query GetClients($includeArchived: Boolean) {
    clients(includeArchived: $includeArchived) {
      ...ClientDetails
    }
  }

  ${CLIENT_FRAGMENT}
`;

export const GET_CLIENT_OVERVIEWS = gql`
  query GetClientOverviews($includeArchived: Boolean) {
    clients(includeArchived: $includeArchived) {
      ...ClientOverview
    }
  }

  ${CLIENT_OVERVIEW_FRAGMENT}
`;

export const GET_CLIENT = gql`
  query Client($_id: ID!) {
    client(_id: $_id) {
      ...ClientDetails
    }
  }

  ${CLIENT_FRAGMENT}
`;

export const DELETE_CLIENT = gql`
  mutation DeleteClient($_id: ID!, $permanent: Boolean) {
    deleteClient(_id: $_id, permanent: $permanent) {
      ...ClientDetails
    }
  }

  ${CLIENT_FRAGMENT}
`;

export const RESTORE_CLIENT = gql`
  mutation RestoreClient($_id: ID!) {
    restoreClient(_id: $_id) {
      ...ClientDetails
    }
  }

  ${CLIENT_FRAGMENT}
`;

export const UPDATE_CLIENT = gql`
  mutation UpdateClient(
    $department: [ID!]
    $_id: ID!
    $location: [ID!]
    $givenName: String
    $familyName: String
    $entities: [ID!]
  ) {
    updateClient(
      department: $department
      _id: $_id
      location: $location
      givenName: $givenName
      familyName: $familyName
      entities: $entities
    ) {
      client {
        ...ClientDetails
      }
      members {
        ...EntityMemberDetails
      }
    }
  }

  ${CLIENT_FRAGMENT}
  ${ENTITY_MEMBER_FRAGMENT}
`;
